export function useCommonEventHandler() {
    const commonEventHandler = (eventData) => {
        this.$emit('common-event-handler', eventData);
    };
  
    return { commonEventHandler };
}